import { useQuery } from "@apollo/client";
import { GetItApplicationReportOverviewData, GetItApplicationReportOverviewVars } from "../types";
import { GET_IT_APPLICATION_REPORT_OVERVIEW } from "../graphql";

export const useApplicationReportOverview = (applicationUUID: string, locationUUID?: string) => {
  const { data, loading, error } = useQuery<GetItApplicationReportOverviewData, GetItApplicationReportOverviewVars>(GET_IT_APPLICATION_REPORT_OVERVIEW, {
    variables: {
      applicationUUID: applicationUUID,
      ...(locationUUID && { locationUUID: locationUUID }),
    },
    skip: !applicationUUID,
  });

  if (error) console.error('useApplicationReportOverview GraphQL error:', error);

  const overview = data?.getItApplicationReportOverview || null;

  return {
    data: overview,
    loading,
    error,
  };
};